import { isMapMode } from '../maps/util';

export function initOnChangeSubmitForms(): void {
    document.querySelectorAll<HTMLFormElement>( '.onchangeautosubmitableform' ).forEach( ( form: HTMLFormElement ) => {
        form.addEventListener( 'change', ( event: Event ) => {
            if ( isMapMode() && !/\/elucidate/.test( form.action ) ) {
                event.preventDefault();

                const mapRoot = document.querySelector<HTMLElement>( '#twc__map-search-map' );

                if ( !mapRoot ) {
                    return;
                }

                mapRoot.dispatchEvent( new CustomEvent( 'twc:mapsearch:click-navigateLink', {
                    bubbles: true,
                    detail: {
                        originalEvent: event,
                    },
                } ) );
            } else {
                if ( /\/elucidate/.test( form.action )  ) {
                    if ( !event.target || !( event.target instanceof HTMLInputElement ) ) {
                        return;
                    }

                    event.target.setAttribute( 'checked', 'true' );

                    const submittedValue = event.target.value;

                    form.querySelectorAll<HTMLInputElement>( `[name="${event.target.name}"]` ).forEach( ( input: HTMLInputElement ) => {
                        if ( input.value !== submittedValue ) {
                            input.checked = false;
                            input.setAttribute( 'checked', 'false' );
                        }
                    } );
                }

                form.submit();
            }
        } );
    } );
}
